var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"blockquote container"},[_c('blockquote-photo',{attrs:{"invertColor":_vm.invertColor,"img":_vm.img}}),_c('blockquote',[_c('p',{class:{'quote': _vm.blockquote}},[_vm._t("blockquote")],2),_c('footer',[_vm._t("sign")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }